import type { CoaStatus } from "@/api/diagnostic-chart-of-accounts";
import { COA_STATUS_COLORS } from "@/components/projects/diagnostic/selectors/chartOfAccounts";

/** A letra do status com a cor dele: a cor nunca aparece sozinha. */
export function CoaStatusBadge({ status }: { status: CoaStatus }) {
  return (
    <span
      className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-sm font-mono text-[11px] font-semibold text-white"
      style={{ backgroundColor: COA_STATUS_COLORS[status] }}
    >
      {status}
    </span>
  );
}
